import { apiErrorToToast } from "@/lib/utils";
import { applyForEdition } from "@/requests/applications/apply-for-edition.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { buildSearchApplicationsQueryKey } from "./search-applications.hook";

export const useApplyForEdition = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: applyForEdition,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["applications", "edition", variables.editionId],
      });
      queryClient.invalidateQueries({
        queryKey: buildSearchApplicationsQueryKey({
          companyId: variables.companyId,
        }),
      });
    },
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });

  return mutation;
};
